/* Sizing Guide page: unit toggle, chest slider with row highlight, and the size finder dialog.
   Garment numbers come from the #sg-data JSON that sections/sizing-guide.liquid emits.
   Sizing rules: target chest = your chest + the garment's ease for the chosen fit; the size whose "chest all round"
   is closest wins, with sizes smaller than the target penalised 1.5x. Same rule and same tee ease values as
   snippets/size-recommender.liquid, so the product page finder and this page agree. */
(function () {
  var root = document.querySelector('[data-sg]');
  var dataEl = document.getElementById('sg-data');
  if (!root || !dataEl) return;

  var DATA = JSON.parse(dataEl.textContent);
  var G = {};
  DATA.garments.forEach(function (g) { G[g.key] = g; });
  var ORDER = DATA.garments.map(function (g) { return g.key; });

  var UNITS_KEY = 'lm-size-chart-units';
  // Lowercase a garment's short name for mid-sentence use, keeping all-caps words like "CC" as they are.
  function shortLc(name) { return name.replace(/\b[A-Z][a-z]+\b/g, function (w) { return w.toLowerCase(); }); }
  var IN = 2.54;
  var state = { units: 'in', garment: ORDER[0], chest: 40, fit: 'regular' };

  function $(sel, ctx) { return (ctx || root).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); }
  function track(name, params) {
    try { if (typeof gtag === 'function') gtag('event', 'sizing_guide_' + name, params || {}); } catch (e) {}
  }

  /* ---------- formatting ---------- */
  function fmtNum(n) { var r = Math.round(n * 10) / 10; return (r % 1 === 0) ? String(Math.round(r)) : r.toFixed(1); }
  function fmtLen(inches) {
    return state.units === 'cm' ? fmtNum(inches * IN) + ' cm' : fmtNum(inches) + '″';
  }
  function fmtRound(inches) {
    return state.units === 'cm' ? Math.round(inches * IN) + ' cm' : Math.round(inches) + '″';
  }
  function fitWord(fit) { return fit === 'fitted' ? 'fitted' : fit === 'relaxed' ? 'relaxed' : 'regular'; }

  /* ---------- sizing math ---------- */
  function chestOf(g, i) { return g.width[i] * 2; }
  function nearest(values, target) {
    var best = 0, min = Infinity;
    values.forEach(function (v, i) {
      var diff = v - target;
      var dist = diff < 0 ? Math.abs(diff) * 1.5 : diff;
      if (dist < min) { min = dist; best = i; }
    });
    return best;
  }
  function pickByChest(g, bodyChest, fit) {
    var target = bodyChest + g.ease[fit];
    var chests = g.sizes.map(function (_, i) { return chestOf(g, i); });
    var idx = nearest(chests, target);
    return { idx: idx, target: target, chests: chests };
  }
  function pickByWidth(g, width) {
    return nearest(g.width, width);
  }
  function roomText(room) {
    var abs = Math.abs(room);
    if (room >= 0.75) return 'about ' + fmtRound(room) + ' of room';
    if (room > -0.75) return 'right at your chest, a close fit';
    return 'about ' + fmtRound(abs) + ' under your chest, a hugging fit';
  }
  /* If the runner-up size was nearly as close, say so. */
  function borderline(g, pick) {
    var chosen = pick.idx, alt = -1;
    var above = pick.chests[chosen] >= pick.target;
    if (above && chosen > 0) alt = chosen - 1;
    if (!above && chosen < g.sizes.length - 1) alt = chosen + 1;
    if (alt < 0) return '';
    function dist(i) { var d = pick.chests[i] - pick.target; return d < 0 ? Math.abs(d) * 1.5 : d; }
    if (Math.abs(dist(alt) - dist(chosen)) > 1.25) return '';
    var lo = Math.min(chosen, alt), hi = Math.max(chosen, alt);
    return 'You are near the line between ' + g.sizes[lo] + ' and ' + g.sizes[hi] + '. Go ' + g.sizes[hi] +
      ' if you like a little more room, ' + g.sizes[lo] + ' if you like it closer.';
  }

  /* Chest estimate from height, weight and build (same table as the product page finder). */
  var chestMen = [
    [64,120,34,35,37,38],[64,140,35,37,38,40],[64,160,37,39,40,42],[64,180,39,41,42,44],
    [66,130,34,36,37,39],[66,150,36,38,39,41],[66,170,38,40,41,43],[66,190,40,42,43,45],[66,210,42,44,45,47],
    [68,140,35,37,38,40],[68,160,37,38,40,42],[68,180,39,41,42,44],[68,200,41,43,44,46],[68,220,43,45,46,48],
    [69,150,36,37,39,41],[69,170,37,39,41,43],[69,190,40,42,43,45],[69,210,42,43,44,46],
    [70,150,36,38,39,41],[70,170,38,40,41,43],[70,190,40,42,43,45],[70,210,42,44,45,47],[70,230,44,46,47,49],
    [72,160,37,39,40,42],[72,180,39,41,43,45],[72,200,41,43,45,47],[72,220,43,45,46,48],[72,240,45,47,48,50],
    [74,170,38,40,41,43],[74,190,40,42,43,45],[74,210,42,44,45,47],[74,230,44,46,47,49],
    [76,180,39,41,42,44],[76,200,41,43,44,46],[76,220,43,45,46,48],[76,250,46,48,49,51]
  ];
  var chestWomen = [
    [60,100,32,34,35,36],[60,120,34,36,37,38],[60,140,36,38,39,40],[60,160,38,40,41,42],
    [62,110,33,35,36,37],[62,130,35,37,38,39],[62,150,37,39,40,41],[62,170,39,41,42,43],
    [64,120,34,36,37,38],[64,140,36,38,39,40],[64,160,38,40,41,42],[64,180,40,42,43,44],
    [66,130,35,37,38,39],[66,150,37,39,40,41],[66,170,39,41,42,43],[66,190,41,43,44,45],
    [68,140,36,38,39,40],[68,160,38,40,41,42],[68,180,40,42,43,44],[68,200,42,44,45,46],
    [70,150,37,39,40,41],[70,170,39,41,42,43],[70,190,41,43,44,45]
  ];
  var buildCol = { slim: 2, regular: 3, athletic: 4, broad: 5, full: 5 };
  function lookupChest(hIn, wLbs, build, gender) {
    var tbl = gender === 'women' ? chestWomen : chestMen;
    var col = buildCol[build] || 3;
    var heights = [];
    tbl.forEach(function (r) { if (heights.indexOf(r[0]) < 0) heights.push(r[0]); });
    heights.sort(function (a, b) { return a - b; });
    var hLow = heights[0], hHigh = heights[heights.length - 1];
    for (var i = 0; i < heights.length - 1; i++) {
      if (hIn >= heights[i] && hIn <= heights[i + 1]) { hLow = heights[i]; hHigh = heights[i + 1]; break; }
    }
    if (hIn <= heights[0]) { hLow = heights[0]; hHigh = hLow; }
    if (hIn >= heights[heights.length - 1]) { hLow = heights[heights.length - 1]; hHigh = hLow; }
    function interpW(h) {
      var rows = tbl.filter(function (r) { return r[0] === h; }).sort(function (a, b) { return a[1] - b[1]; });
      if (!rows.length) return null;
      if (wLbs <= rows[0][1]) return rows[0][col];
      if (wLbs >= rows[rows.length - 1][1]) return rows[rows.length - 1][col];
      for (var j = 0; j < rows.length - 1; j++) {
        if (wLbs >= rows[j][1] && wLbs <= rows[j + 1][1]) {
          var t = (wLbs - rows[j][1]) / (rows[j + 1][1] - rows[j][1]);
          return rows[j][col] + t * (rows[j + 1][col] - rows[j][col]);
        }
      }
      return rows[0][col];
    }
    var cLow = interpW(hLow), cHigh = interpW(hHigh);
    if (cLow === null) return cHigh;
    if (cHigh === null) return cLow;
    if (hLow === hHigh) return cLow;
    return cLow + ((hIn - hLow) / (hHigh - hLow)) * (cHigh - cLow);
  }

  /* ---------- units ---------- */
  function setUnits(units, persist) {
    state.units = units === 'cm' ? 'cm' : 'in';
    root.setAttribute('data-units', state.units);
    $$('[data-sg-units]').forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-sg-units') === state.units ? 'true' : 'false');
    });
    if (persist) { try { localStorage.setItem(UNITS_KEY, state.units); } catch (e) {} }
    renderSlider();
    renderFinderUnits();
  }

  /* ---------- style picker + panels ---------- */
  function setGarment(key, scroll) {
    if (!G[key]) return;
    state.garment = key;
    $$('[data-sg-tile]').forEach(function (t) {
      t.setAttribute('aria-selected', t.getAttribute('data-sg-tile') === key ? 'true' : 'false');
    });
    $$('[data-sg-panel]').forEach(function (p) {
      p.hidden = p.getAttribute('data-sg-panel') !== key;
    });
    syncVideos();
    renderSlider();
    if (scroll) {
      var panel = $('[data-sg-panel="' + key + '"]');
      if (panel) panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  /* Size videos load only when their panel is showing (they are about 1 MB each) and pause when it is hidden.
     With reduced motion on, the video keeps its poster and shows controls instead of autoplaying. */
  var reduceMotion = false;
  try { reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
  function syncVideos() {
    $$('[data-sg-video]').forEach(function (v) {
      var panel = v.closest('[data-sg-panel]');
      var showing = panel && !panel.hidden;
      if (showing) {
        if (!v.getAttribute('src')) { v.setAttribute('src', v.getAttribute('data-src')); v.load(); }
        if (reduceMotion) { v.controls = true; return; }
        var p = v.play();
        /* Autoplay blocked (iOS Low Power Mode and the like): show the native controls so a tap still plays it.
           An AbortError only means the panel was switched again before playback started, so it is ignored. */
        if (p && p.catch) p.catch(function (err) { if (!err || err.name !== 'AbortError') v.controls = true; });
      } else if (!v.paused) {
        v.pause();
      }
    });
  }

  function renderSlider() {
    var g = G[state.garment];
    var pick = pickByChest(g, state.chest, state.fit);
    var pct = ((state.chest - 30) / 30) * 100;
    $$('[data-sg-panel]').forEach(function (panel) {
      var slider = $('[data-sg-slider]', panel);
      if (slider) { slider.value = state.chest; slider.style.setProperty('--sg-pct', pct + '%'); }
      var val = $('[data-sg-slider-value]', panel);
      if (val) val.textContent = fmtRound(state.chest);
      $$('[data-sg-fit]', panel).forEach(function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-sg-fit') === state.fit ? 'true' : 'false');
      });
    });
    var panel = $('[data-sg-panel="' + state.garment + '"]');
    if (!panel) return;
    $$('[data-sg-row]', panel).forEach(function (row) {
      row.classList.toggle('is-you', Number(row.getAttribute('data-sg-row')) === pick.idx);
    });
    var note = $('[data-sg-slider-note]', panel);
    if (note) {
      var room = pick.chests[pick.idx] - state.chest;
      note.innerHTML = 'A ' + fmtRound(state.chest) + ' chest in a <strong>' + fitWord(state.fit) + '</strong> fit is our <strong>' +
        g.sizes[pick.idx] + '</strong>: ' + fmtLen(pick.chests[pick.idx]) + ' all round, ' + roomText(room) + '.';
    }
  }

  /* ---------- finder ---------- */
  var dialog = $('#sg-finder');
  var f = {
    garment: null, path: null, step: null, history: [],
    gender: null, build: null, fit: null, result: null
  };
  var STEP_FLOW = { measure: ['measure', 'result'], chest: ['chest', 'fit', 'result'], estimate: ['about', 'fit', 'result'] };

  function openFinder(garment, path) {
    f.garment = garment && G[garment] ? garment : null;
    f.path = path && STEP_FLOW[path] ? path : null;
    f.history = [];
    f.gender = null; f.build = null; f.fit = null; f.result = null;
    $$('.sg-choice', dialog).forEach(function (c) { c.classList.remove('is-selected'); });
    $$('[data-sg-input]', dialog).forEach(function (i) { i.value = ''; });
    renderFinderUnits();
    goStep(f.garment ? (f.path ? STEP_FLOW[f.path][0] : 'path') : 'garment', true);
    if (typeof dialog.showModal === 'function') { if (!dialog.open) dialog.showModal(); }
    else dialog.setAttribute('open', '');
    track('finder_open', { garment: f.garment || '', path: f.path || '' });
  }
  function closeFinder() {
    if (typeof dialog.close === 'function' && dialog.open) dialog.close(); else dialog.removeAttribute('open');
  }
  function goStep(step, fresh) {
    if (!fresh && f.step) f.history.push(f.step);
    f.step = step;
    $$('[data-sg-step]', dialog).forEach(function (s) {
      s.classList.toggle('is-active', s.getAttribute('data-sg-step') === step);
    });
    var g = f.garment ? G[f.garment] : null;
    $$('[data-sg-garment-lc]', dialog).forEach(function (el) { el.textContent = g ? shortLc(g.short) : 'shirt'; });
    var back = $('[data-sg-back]', dialog), next = $('[data-sg-next]', dialog), restart = $('[data-sg-restart]', dialog);
    var isResult = step === 'result';
    back.hidden = isResult || f.history.length === 0;
    next.hidden = isResult;
    restart.hidden = !isResult;
    if (!isResult) {
      var last = f.path && STEP_FLOW[f.path].indexOf(step) === STEP_FLOW[f.path].length - 2;
      next.textContent = last ? 'See my size' : 'Continue';
      validate();
    }
    $('.sg-finder__body', dialog).scrollTop = 0;
    var focusable = $('.sg-fstep.is-active button, .sg-fstep.is-active input, .sg-fstep.is-active select', dialog);
    if (focusable && !isResult) focusable.focus({ preventScroll: true });
  }
  function nextStep() {
    if (f.step === 'garment') { if (f.garment) goStep(f.path ? STEP_FLOW[f.path][0] : 'path'); return; }
    if (f.step === 'path') { if (f.path) goStep(STEP_FLOW[f.path][0]); return; }
    var flow = STEP_FLOW[f.path];
    var i = flow.indexOf(f.step);
    var nxt = flow[i + 1];
    if (nxt === 'result') { showResult(); return; }
    goStep(nxt);
  }
  function backStep() {
    var prev = f.history.pop();
    if (prev) { f.step = null; goStep(prev, true); }
  }
  function inputInches(name) {
    var el = $('[data-sg-input="' + name + '"]', dialog);
    var v = parseFloat(el && el.value);
    if (!isFinite(v)) return NaN;
    return state.units === 'cm' ? v / IN : v;
  }
  function validate() {
    var ok = false;
    switch (f.step) {
      case 'garment': ok = !!f.garment; break;
      case 'path': ok = !!f.path; break;
      case 'measure': { var w = inputInches('width'); ok = w >= 10 && w <= 45; break; }
      case 'chest': { var c = inputInches('chest'); ok = c >= 22 && c <= 80; break; }
      case 'about': ok = !!f.gender && !!$('[data-sg-input="height"]', dialog).value && !!$('[data-sg-input="weight"]', dialog).value && !!f.build; break;
      case 'fit': ok = !!f.fit; break;
    }
    $('[data-sg-next]', dialog).disabled = !ok;
  }
  function renderFinderUnits() {
    if (!dialog) return;
    var w = $('[data-sg-input="width"]', dialog), c = $('[data-sg-input="chest"]', dialog);
    if (w) w.placeholder = state.units === 'cm' ? 'e.g. 51' : 'e.g. 20';
    if (c) c.placeholder = state.units === 'cm' ? 'e.g. 102' : 'e.g. 40';
  }

  function showResult() {
    var g = G[f.garment];
    var fit = f.fit || 'regular';
    var bodyChest, pick, line;
    if (f.path === 'measure') {
      var w = inputInches('width');
      var idx = pickByWidth(g, w);
      bodyChest = g.width[idx] * 2 - g.ease.regular;
      var chests = g.sizes.map(function (_, i) { return chestOf(g, i); });
      pick = { idx: idx, target: w * 2, chests: chests };
      line = 'Measures ' + fmtLen(g.width[idx]) + ' across laid flat, the closest to the ' + fmtLen(w) + ' you measured. ' +
        fmtLen(chests[idx]) + ' all round.';
    } else {
      if (f.path === 'chest') {
        bodyChest = inputInches('chest');
        pick = pickByChest(g, bodyChest, fit);
        line = fmtLen(pick.chests[pick.idx]) + ' all round, ' + roomText(pick.chests[pick.idx] - bodyChest) + ' on a ' + fmtRound(bodyChest) + ' chest.';
      } else {
        var h = parseFloat($('[data-sg-input="height"]', dialog).value);
        var wt = parseFloat($('[data-sg-input="weight"]', dialog).value);
        bodyChest = lookupChest(h, wt, f.build, f.gender);
        pick = pickByChest(g, bodyChest, fit);
        line = 'Your height, weight and build put your chest around ' + fmtRound(bodyChest) + '. The ' + g.sizes[pick.idx] + ' is ' +
          fmtLen(pick.chests[pick.idx]) + ' all round, ' + roomText(pick.chests[pick.idx] - bodyChest) + '.';
      }
    }
    f.result = { size: g.sizes[pick.idx], bodyChest: bodyChest, fit: fit };
    $('[data-sg-result-garment]', dialog).textContent = g.short;
    $('[data-sg-result-size]', dialog).textContent = g.sizes[pick.idx];
    $('[data-sg-result-line]', dialog).textContent = line;
    var hintEl = $('[data-sg-result-hint]', dialog);
    var hint = f.path === 'measure' ? '' : borderline(g, pick);
    hintEl.textContent = hint;
    hintEl.hidden = !hint;
    var shop = $('[data-sg-result-shop]', dialog);
    shop.href = g.collection;
    shop.textContent = 'Shop ' + g.plural + ' →';
    var others = $('[data-sg-result-others]', dialog);
    others.innerHTML = '';
    ORDER.forEach(function (key) {
      if (key === g.key) return;
      var og = G[key];
      var op = pickByChest(og, bodyChest, fit);
      var li = document.createElement('li');
      li.innerHTML = og.short + ' <strong>' + og.sizes[op.idx] + '</strong>';
      others.appendChild(li);
    });
    goStep('result');
    track('recommendation', { garment: g.key, path: f.path, fit: fit, size: g.sizes[pick.idx] });
  }

  /* Deep link: /pages/sizing-guide#find-<garment> opens the finder on that garment (product page "Suggest my size" buttons). */
  var hashMatch = /^#find-([a-z0-9-]+)$/.exec(window.location.hash || '');
  if (hashMatch && G[hashMatch[1]]) {
    setGarment(hashMatch[1], false);
    setTimeout(function () { openFinder(hashMatch[1], null); }, 0);
  }

  /* ---------- events ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var el;

    if ((el = t.closest('[data-sg-units]')) && root.contains(el)) { setUnits(el.getAttribute('data-sg-units'), true); return; }
    if ((el = t.closest('[data-sg-tile]')) && root.contains(el)) { setGarment(el.getAttribute('data-sg-tile'), true); track('style_pick', { garment: el.getAttribute('data-sg-tile') }); return; }
    if ((el = t.closest('[data-sg-fit]')) && root.contains(el)) { state.fit = el.getAttribute('data-sg-fit'); renderSlider(); return; }
    if ((el = t.closest('[data-sg-open]')) && root.contains(el)) {
      var gk = el.getAttribute('data-sg-open');
      openFinder(gk || (el.hasAttribute('data-sg-path') ? state.garment : null), el.getAttribute('data-sg-path'));
      return;
    }
    if (!dialog || !dialog.contains(t)) {
      if (dialog && dialog.open && t === dialog) closeFinder();
      return;
    }
    if (t.closest('[data-sg-close]')) { closeFinder(); return; }
    if (t.closest('[data-sg-next]')) { nextStep(); return; }
    if (t.closest('[data-sg-back]')) { backStep(); return; }
    if (t.closest('[data-sg-restart]')) { openFinder(null, null); return; }
    if ((el = t.closest('[data-sg-pick-garment]'))) { select(el, '[data-sg-pick-garment]'); f.garment = el.getAttribute('data-sg-pick-garment'); validate(); return; }
    if ((el = t.closest('[data-sg-pick-path]'))) { select(el, '[data-sg-pick-path]'); f.path = el.getAttribute('data-sg-pick-path'); validate(); nextStep(); return; }
    if ((el = t.closest('[data-sg-pick-gender]'))) {
      select(el, '[data-sg-pick-gender]'); f.gender = el.getAttribute('data-sg-pick-gender'); f.build = null;
      $$('[data-sg-builds]', dialog).forEach(function (b) { b.hidden = b.getAttribute('data-sg-builds') !== f.gender; $$('.sg-choice', b).forEach(function (c) { c.classList.remove('is-selected'); }); });
      validate(); return;
    }
    if ((el = t.closest('[data-sg-pick-build]'))) { select(el, '[data-sg-builds]:not([hidden]) [data-sg-pick-build]'); f.build = el.getAttribute('data-sg-pick-build'); validate(); return; }
    if ((el = t.closest('[data-sg-pick-fit]'))) { select(el, '[data-sg-pick-fit]'); f.fit = el.getAttribute('data-sg-pick-fit'); validate(); return; }
    if (t.closest('[data-sg-result-chart]')) {
      if (f.result) {
        state.fit = f.result.fit;
        state.chest = Math.min(60, Math.max(30, Math.round(f.result.bodyChest)));
        closeFinder();
        setGarment(f.garment, true);
      }
      return;
    }
  });
  function select(el, groupSel) {
    $$(groupSel, dialog).forEach(function (c) { c.classList.remove('is-selected'); });
    el.classList.add('is-selected');
  }

  root.addEventListener('input', function (e) {
    var t = e.target;
    if (t.matches('[data-sg-slider]')) { state.chest = Number(t.value); renderSlider(); return; }
    if (dialog && dialog.contains(t)) validate();
  });
  root.addEventListener('change', function (e) {
    if (dialog && dialog.contains(e.target)) validate();
  });
  if (dialog) {
    dialog.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.matches('input')) { e.preventDefault(); if (!$('[data-sg-next]', dialog).disabled) nextStep(); }
    });
  }

  /* ---------- init ---------- */
  var savedUnits = 'in';
  try { savedUnits = localStorage.getItem(UNITS_KEY) === 'cm' ? 'cm' : 'in'; } catch (e) {}
  setUnits(savedUnits, false);
  setGarment(state.garment, false);
})();
